import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BooleanField,
  DataTable,
  DateTimeField,
  Field,
} from '../../../commons/DataTable';
import ActionsField from './ActionsField';
import BadgeField from './BadgeField';
import { ADMIN_TYPES } from '../../../App';
import SupplierAgreementField from '../../../commons/DataTable/SupplierAgreementField';

function AgreementsTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  profile,
  handleFileListView,
  handleDelete,
  fetchExternalAgreements,
}) {
  const [t] = useTranslation();

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <Field title="Nome contratto" source="name" className="text-center" />
      <Field
        title="Amministratore"
        source="profile.businessName"
        className="text-center"
        visible={!ADMIN_TYPES.includes(profile.type)}
      />
      <Field
        title="Codice fiscale amministratore"
        source="profile.fiscalCode"
        className="text-center"
        visible={!ADMIN_TYPES.includes(profile.type)}
      />
      <Field
        title="Nome Condominio"
        source="condo.name"
        className="text-center"
      />
      <Field
        title="Partita IVA condominio"
        source="condo.vatCode"
        className="text-center"
      />
      <SupplierAgreementField
        title="Tipo fornitore"
        source="isExternalSupplier"
        className="text-center"
        visible={!['SUPPLIER'].includes(profile.type)}
      />
      <Field
        title="Fornitore"
        source="supplier.businessName"
        className="text-center"
        visible={!['SUPPLIER'].includes(profile.type)}
      />
      <Field
        title="Codice Fiscale Fornitore"
        source="supplier.fiscalCode"
        className="text-center"
        visible={!['SUPPLIER'].includes(profile.type)}
      />
      <DateTimeField
        title="Data creazione"
        source="createdAt"
        format="DD/MM/YYYY"
      />
      <ActionsField
        title="Azioni"
        handleFileListView={handleFileListView}
        fetchExternalAgreements={fetchExternalAgreements}
        handleDelete={handleDelete}
      />
    </DataTable>
  );
}

export default AgreementsTable;
